export default __webpack_public_path__ + "static/media/visa.a706db22.png";